<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="category" label="动态类型:">
                        <el-radio-group v-model="formData.category" @change="categoryChange()">
                            <el-radio :label="1">现场</el-radio>
                            <el-radio :label="2">瞬间</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="userId" label="发布人:">
                        <el-select v-model="formData.userId" filterable remote placeholder="请输入用户名"
                            :remote-method="searchUser" :loading="userLoading">
                            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="targetId" label="关联演出ID:">
                        <el-input v-model.number="formData.targetId" placeholder="请输入关联演出ID"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="attachInfo" label="@用户:">
                        <el-select v-model="formData.attachInfo" filterable multiple remote placeholder="请输入用户名"
                            :remote-method="searchAtUser" :loading="userLoading" value-key="userId"
                            @change="selectAtt()" :multiple-limit="25">
                            <el-option v-for="item in atUserList" :key="item.userId" :label="item.text" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="type" label="内容类型:">
                        <el-radio-group v-model="formData.type" @change="typeChange">
                            <el-radio :label="2">图片</el-radio>
                            <el-radio :label="3">视频</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="formData.category == 1" :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="topicIds" label="关联话题:">
                        <span slot="label">关联话题: <small>最多关联3个话题</small></span>
                        <el-select v-model="formData.topicIds" filterable multiple remote placeholder="请输入话题名"
                            :remote-method="searchTopic" :loading="topicLoading" :multiple-limit="3">
                            <el-option v-for="item in topicList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col v-if="formData.type == 2" :xs="24" :xl="16">
                    <el-form-item prop="photoUrl" label="图片:">
                        <span slot="label">图片: <small>支持格式为JPG、PNG,不大于10M,最多上传9张</small></span>
                        <el-upload action="" list-type="picture-card" accept="image/png,image/jpeg"
                            :http-request="uploadImage" multiple :on-remove="imageRemove" :limit="9"
                            :on-exceed="imageExceed" :before-upload="beforeImageUpload" :file-list="imageList">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <template v-if="formData.type == 3">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="coverUrl" label="视频封面:">
                            <ImageUpload :url.sync="formData.coverUrl" :urlFull.sync="coverUrl"></ImageUpload>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="multimediaUrl" label="视频文件:">
                            <VideoUpload :url.sync="formData.multimediaUrl" :urlFull.sync="videoUrl"
                                :cover.sync="coverUrl" @onSuccess="$refs.formData.clearValidate('multimediaUrl')">
                            </VideoUpload>
                        </el-form-item>
                    </el-col>
                </template>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="content" label="内容:">
                        <el-input v-model="formData.content" type="textarea" :rows="4" placeholder="请输入内容"
                            :maxlength="contentLength" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返回</el-button>
            <el-button v-if="$utils.have('/article/new')" type="primary" @click="onSubmit" :loading="btnLoading">确认提交
            </el-button>
        </div>
    </div>
</template>

<script>
import { fetchUser, fetchTopic, uploadImg } from '@/assets/js/commonApi';
import ImageUpload from "@/components/ImageUpload";
import VideoUpload from "@/components/VideoUpload";

export default {
    components: { ImageUpload, VideoUpload },
    data() {
        return {
            formData: {
                attachInfo: [],
                category: 1,
                content: "",
                mood: "",
                multimediaUrl: "",
                photoUrl: [],
                showType: 1,
                targetId: "",
                targetType: 1,
                title: "",
                topicIds: [],
                type: 2,
                userId: "",
                coverUrl: ""
            },
            rules: {
                userId: [{ required: true, message: "请选择发布人" }],
                targetId: [{ pattern: /^[0-9]+$/, message: "请输入正确的ID" }],
                photoUrl: [{ required: true, message: "请上传照片" }],
                multimediaUrl: [{ required: true, message: "请上传视频" }],
                coverUrl: [{ required: true, message: "请上传视频封面" }],
                content: [{ validator: this.validateContent}],
            },

            userLoading: false,
            userList: [],

            topicLoading: false,
            topicList: [],

            atUserList: [],

            imageList: [],

            btnLoading: false,
            uploadLoading: false,

            videoUrl: "",
            coverUrl: "",

            contentLength: 500
        }
    },
    methods: {
        validateContent(rule, value, callback) {
            if (value.length > this.contentLength) {
                callback(new Error(`内容长度不能超过${this.contentLength}`));
            } else {
                callback();
            }
        },
        // 搜索用户
        searchUser(query) {
            this.gethUser(query, 0, "userList");
        },
        searchAtUser(query) {
            this.gethUser(query, 0, "atUserList");
        },
        async gethUser(query, userType, obj) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue: query,
                    userType: userType,
                }).finally(() => {
                    this.userLoading = false;
                });

                const { state, result } = res.data;

                if (state == 1 && result) {
                    if (obj == "atUserList") {
                        this.atUserList = result.map(v => {
                            return {
                                text: v.name,
                                userId: v.id,
                                type: v.userType
                            }
                        })
                    } else {
                        this[obj] = result;
                    }
                }
            }
        },
        //搜索话题
        async searchTopic(query) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchTopic({
                    name: query
                }).finally(() => {
                    this.topicLoading = false;
                });

                const { state, result } = res.data;

                if (state == 1 && result) {
                    this.topicList = result;
                }
            }
        },
        //图片上传
        imageExceed() {
            this.$message.warning('最多上传9张图片');
        },
        beforeImageUpload(file) {
            this.imageList = this.imageList.filter(v => v !== file)
        },
        imageRemove(file, fileList) {
            const _index = this.imageList.findIndex(v => v === file);

            this.formData.photoUrl = this.formData.photoUrl.filter((v, i) => i !== _index);

            this.imageList = fileList;
        },
        async uploadImage(req) {
            const {
                file,
                file: { type, size },
            } = req;

            //格式检查
            const formatVerified =
                type === "image/jpeg" || file.type === "image/png";
            if (!formatVerified) {
                this.$message.error("文件格式存在错误，请重新上传");
                return;
            }
            //大小检查
            const bytesVerified = size / 1024 / 1024 < 10;
            if (!bytesVerified) {
                this.$message.error("图片尺寸错误,请重新上传");
                return;
            }

            // 上传图片
            const formData = new FormData();
            formData.append("file", file);

            // this.uploadLoading = true;
            const res = await uploadImg(formData, () => {
                // this.progress = Math.floor((ev.loaded / ev.total) * 100);
            }).finally(() => {
                // this.uploadLoading = false;
            });

            const { state, result, msg } = res.data;
            if (state == 1) {
                this.imageList.push({
                    url: result.urlFull
                });
                this.formData.photoUrl.push(result.url);
            } else {
                this.$message.error(msg || '上传失败');
            }
        },
        //动态类型选择
        categoryChange() {
            if (this.formData.category === 2) {
                this.contentLength = 30;
            }else{
                this.selectAtt();
            }
            this.$refs["formData"].validateField("content");
        },
        //选择@用户
        selectAtt() {
            if (this.formData.category === 1) {
                let _len = 0;
                this.formData.attachInfo.forEach(v => {
                    _len += (v.text.length + 1);
                })
                this.contentLength = 500 - _len;
            }
        },
        //内容类型选择
        typeChange() {
            this.$refs["formData"].clearValidate(['photoUrl', 'multimediaUrl', 'coverUrl'])
        },

        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    let _attachInfo = [];
                    this.formData.attachInfo.forEach((v, i) => {
                        _attachInfo.push({
                            ...v,
                            text: "@" + v.text,
                        })
                    })
                    let _content = this.formData.content;
                    _attachInfo.map(v => {
                        const _startIndex = _content.length;
                        v.startIndex = _startIndex;
                        v.endIndex = _startIndex + v.text.length;
                        _content += v.text;
                    })

                    this.$request({
                        url: "/article/new",
                        method: "POST",
                        data: {
                            ...this.formData,
                            attachInfo: _attachInfo,
                            content: _content,
                            photoUrl: this.formData.type == 2 ? this.formData.photoUrl.toString() : this.formData.coverUrl,
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            })
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
</style>